import * as types from './Types'

const initialState = {
    businessActivity: [],
    userData: [],
    exportData: {},
    tableData: [],
    loading: true
}

export const BusinessReportReducers = (state = initialState, action) => {

    const { type, payload } = action
    switch (type) {
        case types.GET_STANDERD_BUSINESS_ACTIVITY: return {
            ...state,
            businessActivity: payload,
            loading: false
        }
        case types.GET_USERS_DATA: return {
            ...state,
            userData: payload,
            loading: false
        }
        case types.EXPORT_PARAMETER_STORE: return {
            ...state,
            exportData: payload,
            loading: false
        }
        case types.TABLE_DATA_STORE: return {
            ...state,
            tableData: payload,
            loading: false
        }
        case types.EMPTY_STORE: return {
            ...state,
            exportData: initialState.exportData,
            tableData: initialState.tableData
        }
        default:
            return state
    }
}

export default BusinessReportReducers